import { forwardRef, useRef } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'

import { TextContainer } from 'components/container'
import { Title } from 'components/misc'
import { VideoCMS } from 'components/video-cms'
import { Graphics, Section } from './styled'

export const Bonesetters = forwardRef<HTMLDivElement, {}>((_, ref) => {
  const graphicsRef = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({
    target: graphicsRef,
    offset: ['start end', `end start`],
  })
  const y = useTransform(scrollYProgress, [0, 1], [400, -400])

  return (
    <Section ref={ref}>
      <TextContainer>
        <Graphics ref={graphicsRef}>
          <motion.div style={{ y }} />
        </Graphics>
        <Title data-menu-title="костоломы">Костоломы</Title>
        <p>
          Разбивание хребтовой кости быка или коровы (хээр шаалган, что означает с бурятского "проверить кость") – древняя национальная игра, которая постепенно уходила в небытие. Однако бурятские энтузиасты в 2013 году решили провести соревнования в поселении Хойто-Гол. С этого момента началось стремительное возрождение древней традиции. Разбивание хребтовой кости стало настолько популярным, что в 2020 году его признали национальным видом спорта Бурятии.
        </p>
        <p>
          Кость – предварительно очищенную и вываренную – держат в одной руке и раскалывают ударом другой. Костоломы уверены, что перебивание костей становится испытанием для человека, своего рода энергетическим выбросом, когда дух и тело сливаются воедино. Буряты относят свое состояние к духам предков и придают игре сакральный смысл: разбил кость – значит, выпустил душу животного, которая может заново переродиться. Победить может тот, кто обуздает свой дух. Со злыми помыслами, страхами, неуверенностью победить нельзя.
        </p>

        <VideoCMS
          poster="https://gdb.currenttime.tv/01000000-0a00-0242-6e87-08dc1df9b4bf_w738.png"
          localhost={'https://currenttime.tv'}
          id="32796428"
        />
      </TextContainer>
    </Section>
  )
})
